import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid main-wrapper d-flex justify-content-between" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "d-none d-xl-block"
}
const _hoisted_5 = {
  class: "collapse navbar-collapse d-md-flexjustify-content-md-end",
  id: "navbarText"
}
const _hoisted_6 = {
  class: "navbar-nav mb-2 mb-lg-0",
  style: {"margin-right":"6.5px"}
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_14 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-md navbar-primary navbar-light mx-auto pt-md-4 mb-md-4 px-md-2 col-lg-10 py-0", { 'navbar-drop': _ctx.showAdminBar }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "navbar-brand skin-navbar-brand",
        target: "_blank",
        href: _ctx.parentCompanyLink,
        style: _normalizeStyle(_ctx.parentCompanyLink === '' ? 'pointer-events: none;' : '')
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.site) + " logo", 1)
      ], 12, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("button", {
        class: "navbar-toggler border-0 fs-6",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarText",
        "aria-controls": "navbarText",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      (_ctx.showTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.homeActive }]),
              href: _ctx.homeResource
            }, "Home", 10, _hoisted_8)
          ]),
          (_ctx.showStart)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { disabled: !_ctx.startEnabled, active: _ctx.startActive }]),
                  href: "/home/userhome"
                }, "Start", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showDesign)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { disabled: !_ctx.designEnabled, active: _ctx.designActive }]),
                  href: "/home/startdesign"
                }, "Design", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTrack)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { disabled: !_ctx.trackEnabled, active: _ctx.trackActive }]),
                  href: _ctx.trackResource
                }, "Track", 10, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showPlan)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { disabled: !_ctx.planEnabled, active: _ctx.planActive }]),
                  href: "/finish"
                }, "Plan", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showLogin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { disabled: false, active: false }]),
                  href: _ctx.loginResource
                }, "Log In", 8, _hoisted_15)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}